var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterInstagramImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.65,
    height: 22.646,
    viewBox: "0 0 22.65 22.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M11.322,7.754a5.806,5.806,0,1,0,5.806,5.806A5.8,5.8,0,0,0,11.322,7.754Zm0,9.581A3.775,3.775,0,1,1,15.1,13.56a3.781,3.781,0,0,1-3.775,3.775Zm7.4-9.818a1.354,1.354,0,1,1-1.354-1.354A1.351,1.351,0,0,1,18.72,7.517Zm3.845,1.374a6.7,6.7,0,0,0-1.829-4.745,6.746,6.746,0,0,0-4.745-1.829c-1.87-.106-7.473-.106-9.343,0A6.736,6.736,0,0,0,1.9,4.141,6.724,6.724,0,0,0,.074,8.886c-.106,1.87-.106,7.473,0,9.343A6.7,6.7,0,0,0,1.9,22.974,6.754,6.754,0,0,0,6.648,24.8c1.87.106,7.473.106,9.343,0a6.7,6.7,0,0,0,4.745-1.829,6.746,6.746,0,0,0,1.829-4.745c.106-1.87.106-7.468,0-9.338ZM20.15,20.235A3.821,3.821,0,0,1,18,22.388c-1.491.591-5.028.455-6.675.455s-5.189.131-6.675-.455a3.821,3.821,0,0,1-2.153-2.153C1.9,18.745,2.04,15.208,2.04,13.56s-.131-5.189.455-6.675A3.821,3.821,0,0,1,4.647,4.733c1.491-.591,5.028-.455,6.675-.455s5.189-.131,6.675.455A3.821,3.821,0,0,1,20.15,6.885c.591,1.491.455,5.028.455,6.675S20.741,18.75,20.15,20.235Z",
    transform: "translate(0.005 -2.237)",
    fill: "#191919"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramImg);
export default __webpack_public_path__ + "static/media/footerInstagramImg.f6b6f4db97bfda9bbef770967fe56dd0.svg";
export { ForwardRef as ReactComponent };